import { createFileRoute } from "@tanstack/react-router";
import { ContractFormPage } from "@/features/contracts/contract-form-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/nowy")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.kontrakty",
			location.pathname,
		);
	},
	component: ContractFormPage,
});
